import { render, staticRenderFns } from "./ComparisonPlanTableItemParts.vue?vue&type=template&id=5e5bed1d&scoped=true"
import script from "./ComparisonPlanTableItemParts.vue?vue&type=script&lang=ts"
export * from "./ComparisonPlanTableItemParts.vue?vue&type=script&lang=ts"
import style0 from "./ComparisonPlanTableItemParts.vue?vue&type=style&index=0&id=5e5bed1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5bed1d",
  null
  
)

export default component.exports